import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Checkout from "../pages/checkout/page";
import CheckoutV2 from "../pages/checkoutv2/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/checkout",
    element: <Checkout />,
  },
  {
    path: "/checkoutv2",
    element: <CheckoutV2 />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;